export enum EvaluationItemResult {
    Poor = -2,
    Fair = -1,
    Average = 0,
    Good = 1,
    Excellent = 2
}
